export default {
  'report.invoice.form.type': 'Tipo',
  'report.invoice.form.type.partsInvoice': 'Nota Fiscal de Peças',
  'report.invoice.form.type.serviceInvoice': 'Nota Fiscal de Serviços',
  'report.invoice.form.type.consumerInvoice': 'Nota Fiscal de Consumidor',
  'report.invoice.form.situation': 'Situação',
  'report.invoice.form.situation.authorized': 'Autorizada',
  'report.invoice.form.situation.canceled': 'Cancelada',
  'report.invoice.form.situation.denied': 'Denegada',
  'report.invoice.form.situation.inTyping': 'Em Digitação',
  'report.invoice.form.situation.validated': 'Validada',
  'report.invoice.form.situation.processing': 'Processando',
  'report.invoice.form.situation.inCancellation': 'Em Cancelamento',
  'report.invoice.form.detailTheInvoiceItems':
    'Detalhar os Itens da Nota Fiscal?',
  'report.invoice.form.moreOptions': 'Mais Opções',
  'report.invoice.form.moreOptions.selectCustomers': 'Selecionar Clientes',
  'report.invoice.form.moreOptions.selectSuppliers': 'Selecionar Fornecedores',
  'report.invoice.form.selection.cfop': 'CFOP',
  'report.invoice.form.selection.insurer': 'Seguradoras',
  'report.invoice.form.selection.cstpis/cofins': 'CST PIS/COFINS',
};
